var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333C15.0626 18.3333 19.1667 14.2293 19.1667 9.16667C19.1667 4.10406 15.0626 0 10 0C6.61323 0 3.65544 1.83669 2.06835 4.56835L0 2.5V9.16667H6.66667L4.55904 7.05904C5.40408 4.87903 7.52153 3.33333 10 3.33333C13.2217 3.33333 15.8333 5.94501 15.8333 9.16667C15.8333 12.3883 13.2217 15 10 15C8.38917 15 6.93084 14.3471 5.87521 13.2915L3.51819 15.6485C5.17703 17.3073 7.46869 18.3333 10 18.3333Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/Revert.29f8b92cf259dd95d4eabd5eafb0c3a7.svg";
export { ForwardRef as ReactComponent };